import { useGetNotificationCount } from '../../api/use-get-notification-count'

const NotificationCountBubble = () => {
  const { data: notificationCount } = useGetNotificationCount()

  if (notificationCount === 0 || notificationCount === undefined) return null

  return (
    <div className="absolute right-[-6px] top-[-6px]">
      <div className="flex h-5 items-center justify-center rounded-[12px] border border-primary bg-[#d62828] px-1">
        <p className="text-[12px] text-white">{notificationCount}</p>
      </div>
    </div>
  )
}

export default NotificationCountBubble
